module.exports = "pegasus_template/assets/circle-youtube.gif";